module.exports = __webpack_public_path__ + "img/9788959523627.cba0f52b.jpg";